import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';

import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioObjetos';
import { setToken, setUsuario, getToken, deleteToken, deleteUsuario } from '../servicios/ServicioManejadorToken';
import RecuperaContrasena from './RecuperaContrasena';
export default class Login extends Component {
	constructor() {
		super();		
		deleteToken();
		deleteUsuario();
		this.state = {
			usuario: {},
			errores: {}
		};
	}

	asignarValores = (event) => {
		servicioObjetos.asignarAtributosObjeto(event, this, false);
	}

	iniciarSesion = () => {
		let { usuario } = this.state;
		let resultadoValidacion = this.validarFormulario(usuario);
		this.setState({ errores: resultadoValidacion });
		if (servicioObjetos.esObjetoVacio(resultadoValidacion)) {
			servicioHttp.consumirPostHttp('/autenticar?usuario='+usuario.usuario+'&contrasena='+encodeURIComponent(usuario.contrasena), null).then(response => {			
				setToken(response.headers.authorization);
				setUsuario(usuario.usuario);				
				window.location = '/consultareciboquadrum/bienvenido';
			}).catch(error => {
				console.log("error: ",error);
				this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Usuario o contraseña inválidas' });
			});
		}
	}

	validarFormulario = (objetoUsuario) => {
		let errores = {};
		if (!objetoUsuario.usuario)
			errores.usuario = "El campo es requerido";
		if (!objetoUsuario.contrasena)
			errores.contrasena = "El campo es requerido";
			return errores;
	}

	render() {

		let { usuario, errores } = this.state;
		return <div className="login-body">
			<Growl ref={(el) => this.growl = el} />
			<div className="login-panel ui-fluid">
				<div className="login-panel-header">
					<img src="assets/layout/images/login/logo-sapphire-color.png" alt="sapphire" />
				</div>
				<div className="login-panel-content">
					<div className="p-grid">
						<div className="p-col-12">
							<h1>Consulta Recibos Quadrum</h1>
							<h2>Bienvenido, utilice el formulario para iniciar sesión</h2>
						</div>
						<div className="p-col-12">
							<span className="md-inputfield">
								<InputText id="usuario" name="usuario.usuario" className={errores.usuario ? 'p-error' : ''} value={usuario.usuario || ''} onChange={this.asignarValores} style={{ width: '100%' }} />
								<label>Usuario</label>
								{errores.usuario ? <div><br /> <Message severity="error" text={errores.usuario} /> </div> : null}
							</span>
						</div>
						<div className="p-col-12">
							<span className="md-inputfield">
								<InputText type="password" id="contrasena" name="usuario.contrasena" className={errores.contrasena ? 'p-error' : ''} value={usuario.contrasena || ''} onChange={this.asignarValores} style={{ width: '100%' }} />
								<label>Contraseña</label>
								{errores.contrasena ? <div><br /> <Message severity="error" text={errores.contrasena} /> </div> : null}								
							</span>
						</div>
						
						<div className="p-col-6" style={{ textAlign: "right" }}>
							<Button label="Entrar" onClick={this.iniciarSesion} style={{ width: '100%' }} />
						</div>
						<div className="p-col-6"></div>
						<div className="p-col-7" >
							<RecuperaContrasena/>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}